"use strict";

exports.__esModule = true;
exports.ElementUndoControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Undo = require("../../../Core/Undo");
var _dec, _class, _ElementUndoControlGroup;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows a group of controls for undo and redo actions.
 */
var ElementUndoControlGroup = exports.ElementUndoControlGroup = (_dec = _Undo.UndoContext.withContext, _dec(_class = (_ElementUndoControlGroup = /*#__PURE__*/function (_Component) {
  function ElementUndoControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementUndoControlGroup, _Component);
  var _proto = ElementUndoControlGroup.prototype;
  _proto.render = function render() {
    var undo = this.props.undo;
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      large: true,
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.UNDO,
      onClick: undo && undo.undo,
      disabled: !undo || !undo.canUndo
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.REDO,
      onClick: undo && undo.redo,
      disabled: !undo || !undo.canRedo
    }));
  };
  return ElementUndoControlGroup;
}(_react.Component), _ElementUndoControlGroup.defaultProps = {
  undo: undefined
}, _ElementUndoControlGroup)) || _class);